import { FC } from 'react';

import { AccountSettings } from '@shared/components/AccountSettings';

import { useAdminTitleHook } from '../hooks/useAdminTitleHook';

/**
 * 관리자 내 계정 페이지.
 * 내용은 판매자·배송관리자 콘솔과 같은 공용 AccountSettings를 그대로 쓴다
 * (이름·연락처 수정, 비밀번호 변경 — 백엔드는 role 무관한 /auth/me/*).
 */
const AdminSettingsPage: FC = function AdminSettingsPage() {
  //* 상단바에 제목이 나오므로 heading은 넘기지 않는다
  useAdminTitleHook('계정정보');

  return <AccountSettings />;
};

export default AdminSettingsPage;
